import { Link } from 'react-router-dom';

export default function Footer() {
  const productLinks = [
    { name: 'Gaming Consoles', path: '/products' },
    { name: 'Laptops', path: '/products' },
    { name: 'Desktop PCs', path: '/products' },
    { name: 'Accessories', path: '/products' },
  ];

  const supportLinks = [
    { name: 'FAQ', path: '/faq' },
    { name: 'Contact Us', path: '/contact' },
    { name: 'Shipping Info', path: '/faq' },
    { name: 'Returns', path: '/faq' },
  ];

  const companyLinks = [
    { name: 'About Us', path: '/about' },
    { name: 'Privacy Policy', path: '/about' },
    { name: 'Terms of Service', path: '/about' },
  ];

  const socialLinks = [
    { icon: 'ri-facebook-fill', url: '#', label: 'Facebook' },
    { icon: 'ri-twitter-x-fill', url: '#', label: 'Twitter' },
    { icon: 'ri-instagram-fill', url: '#', label: 'Instagram' },
    { icon: 'ri-youtube-fill', url: '#', label: 'YouTube' },
  ];

  return (
    <footer className="bg-gradient-to-br from-[#2C3E50] to-[#34495E] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-4 gap-12 mb-20">
          <div>
            <h4 className="text-sm font-bold uppercase mb-6 tracking-wider">Products</h4>
            <ul className="space-y-3">
              {productLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase mb-6 tracking-wider">Support</h4>
            <ul className="space-y-3">
              {supportLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase mb-6 tracking-wider">Company</h4>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase mb-6 tracking-wider">Connect</h4>
            <div className="flex gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.url}
                  className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-lg transition-colors cursor-pointer"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="flex items-end justify-between pt-8 border-t border-white/10">
          <div>
            <img 
              src="https://static.readdy.ai/image/a527149075599ef0f11873d3eee8c9c7/71fa8bbc36f7c1207af84c51d8954141.png" 
              alt="Tech Cell Corp." 
              className="h-40 mb-2"
            />
          </div>
          <div className="text-right">
            <p className="text-sm text-white/60 mb-2">
              © 2024 Tech Cell Corp. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              className="text-xs text-white/40 hover:text-white/60 transition-colors cursor-pointer"
              target="_blank"
              rel="noopener noreferrer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
